import { onUnmounted, Ref, watch } from "@vue/composition-api";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";

export default function useFundraisingGoalUpdated(userId: Ref<string | null | undefined>) {
  let unsubscribe: () => void = () => {};

  const subscribe = async (userId: string) => {
    unsubscribe();
    const subscription = await providers.FundraisingGoalsProvider.subscribeGoalUpdated(userId, data =>
      emitter.emit(EVENTS.FUNDRAISING_GOAL_UPDATED, data)
    );
    unsubscribe = () => subscription.unsubscribe();
  };

  watch(
    userId,
    (value, oldValue) => {
      value && value !== oldValue ? subscribe(value) : unsubscribe();
    },
    { immediate: true }
  );

  onUnmounted(() => unsubscribe());
}
